import React from 'react';

import InformationEdited from './ActionTypes/InformationEdited';
import EmailAction from './ActionTypes/EmailAction';
import DocumentEdited from './ActionTypes/DocumentEdited';
import DocumentAction from './ActionTypes/DocumentAction';
import ParametrizedEmailSentDetails from './ActionTypes/ParametrizedEmailSentDetails';
import AirlineEmailEventOccurredDetails from './ActionTypes/AirlineEmailEventOccurredDetails';
import TaskList from './ActionTypes/TaskList';
import parseServerChangeLog from './ActionTypes/parseServerLog';
import moment from 'moment';
import { List } from 'semantic-ui-react';

export const setValue = value =>
  Date.parse(value) ? moment.utc(value).format('DD/MM/YYYY HH:mm') : value;

const ItemDetails = ({ details, resourceId, type }) => {
  const displayItemDetails = () => {
    switch (type) {
      case 'EmailSent':
        return <EmailAction details={details} emailId={resourceId} />;
      case 'EmailReceived':
        return <EmailAction details={details} emailId={resourceId} />;
      case 'DocumentAdded':
        return <DocumentAction action="added" details={details} />;
      case 'DocumentRemoved':
        return <DocumentAction action="removed" details={details} />;
      case 'DocumentEdited':
        return <DocumentEdited details={details} />;
      case 'ClaimInformationEdited':
        return <InformationEdited details={details} />;
      case 'TaskCreated':
        return '-';
      case 'TaskCompleted':
        return '-';
      case 'TaskClosed':
        return <TaskList details={details} />;
      case 'TaskRejected':
        return <TaskList details={details} />;
      case 'ParametrizedEmailSent':
        return <ParametrizedEmailSentDetails details={details} />;
      case 'PassengerMovedIn':
        return '-';
      case 'PassengerMovedOut':
        return '-';
      case 'AirlineEmailEventOccurred':
        return <AirlineEmailEventOccurredDetails details={details} />
      default:
        const parsedData = parseServerChangeLog(details);
        return Object.keys(parsedData).map((key, i) => (
          <List.Item key={i}>
            {key}: {setValue(parsedData[key]) || 'null'}
          </List.Item>
        ));
    }
  };
  return displayItemDetails();
};

export default ItemDetails;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/DetailsView.js